import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { MensagensService } from 'max-ng-lib';
import { Observable } from 'rxjs';

import { ManagerRotasService } from '../services/manager-rotas-service';
import { AuthenticationService } from './authentication.service';
import { Permissoes } from './permissoes';
import { PermissoesService } from './permissoes.service';
import {UserToken} from "./user-token";

interface Permissao {
	validarPermissao: boolean;
	chave: Permissoes
}

@Injectable({ providedIn: 'root' })
export class AuthGuardChild implements CanActivateChild {

	USUARIO_LOGADO = "usuariologado";

	constructor(
		private router: Router,
		private permissoesService: PermissoesService,
		private mensagemService: MensagensService,
		private authenticationService: AuthenticationService
		) {

	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<true> | boolean {

		if (!this.authenticationService.estaAutenticado()) {
			this.redirecionarUsuarioSemPermissao();
			return false;
		}

		try {
			const dataRouter: Permissao = childRoute.data as Permissao;
			if (dataRouter && dataRouter.validarPermissao) {
				this.permissoesService.validarPermissaoRota(dataRouter.chave.getValor());
			}
		} catch (error) {
			this.mensagemService.exibaAlertaDeErros([error], 'Usuário sem permissão.');
			this.redirecionarUsuarioSemPermissao();
			return false;
		}

		return true;
	}

	private redirecionarUsuarioSemPermissao() {
		const userToken = this.obtenhaUsuarioLogado();

		if(userToken.permissaoAcesso.indexOf(Permissoes.DASHBOARD.getValor()) >= 0) {
			this.router.navigate(['/pages']);
		} else if (userToken.permissaoAcesso.indexOf(Permissoes.RELATORIOS.getValor()) >= 0) {
			this.router.navigate(['/pages/relatorios/notas-pendentes']);
		} else if (userToken.permissaoAcesso.indexOf(Permissoes.CADASTROS.getValor()) >= 0) {
			this.router.navigate(['/pages/cadastros/horario-trabalho']);
		} else if (userToken.permissaoAcesso.indexOf(Permissoes.GRAFICOS.getValor()) >= 0) {
			this.router.navigate(['/pages/consultas/grafico-entrega']);
		} else if (userToken.permissaoAcesso.indexOf(Permissoes.CONSULTAS.getValor()) >= 0) {
			this.router.navigate(['/pages/consultas/romaneios']);
		} else if (userToken.permissaoAcesso.indexOf(Permissoes.AUTORIZACOES.getValor()) >= 0) {
			this.router.navigate(['/pages/autorizacoes/autorizacao-checkin-fora-raio']);
		} else if (userToken.permissaoAcesso.indexOf(Permissoes.TORRE_DE_CONTROLE.getValor()) >= 0) {
			this.router.navigate(['/pages/torre-de-controle/monitoramento-entregas']);
		} else {
			this.router.navigate(['/pages/tour-melhorias']);
		}
	}

	obtenhaUsuarioLogado(): UserToken {
		return JSON.parse(sessionStorage.getItem(this.USUARIO_LOGADO));
	}
}
